import { useEffect, useRef } from 'react'
import { useAuth } from 'react-auth0'
import { useRouteMatch } from 'react-router-dom'

export default function CustomLogin() {
  const { auth0Client } = useAuth()
  const match = useRouteMatch<{ slug: string }>()
  const redirecting = useRef(false)

  useEffect(() => {
    if (redirecting.current) return
    redirecting.current = true

    auth0Client.loginWithRedirect({
      authorizationParams: {
        login_hint: match?.params?.slug
      }
    })
  }, [auth0Client, match?.params?.slug])

  return null
}
